import _extends from "@babel/runtime/helpers/esm/extends";
var _circle, _path, _circle2, _path2;
import React from 'react';
import { SvgIcon } from '@mui/material';
const Brazil = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcon, _extends({
  viewBox: "0 0 512 512",
  ref: ref
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: "256",
  cy: "256",
  r: "256",
  fill: "#6da544"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "M256 100.174 467.478 256 256 411.826 44.522 256z"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: "256",
  cy: "256",
  r: "89.043",
  fill: "#f0f0f0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M211.478 250.435c-15.484 0-30.427 2.355-44.493 6.725.623 48.64 40.227 87.884 89.015 87.884 30.168 0 56.812-15.017 72.919-37.968-27.557-34.497-69.958-56.641-117.441-56.641zM343.393 273.06c1.072-5.524 1.651-11.223 1.651-17.06 0-49.178-39.866-89.043-89.043-89.043-36.694 0-68.194 22.201-81.826 53.899 12.05-2.497 24.526-3.812 37.305-3.812 51.717-.001 98.503 21.497 131.913 56.016z"
}))));
export default Brazil;